/*=========================================================================================
  File Name: module-agreement-state.js
  Description: Agreement Module State
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
  LinkHistoryAgreement: {},
  Agreement: {},
  ProductAgreement: {}
};